import { gql } from "@apollo/client";

const ActiveUserProjects = gql`
  query allUserProjects($userId: UUID!) {
    allUserProjects(
      condition: { userAppId: $userId }
      orderBy: PROJECT_NAME_ASC
    ) {
      nodes {
        id
        projectName
      }
    }
  }
`;

const hash = "86c068baa0c27a3a5e1b19a20c219452fc28181f184f1f212b617a2ed14b999e";

export { ActiveUserProjects, hash };
